import React from "react";
import "./UserList.css";
import appLib from "../../libs/appLib.mjs";
import TextLabel from "../../Controls/TextLabel.mjs";

const G = window.glob;

const UserList = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			players: G.getStatus('Players'),
			pollInterval: 4000
		};
		this.uid = G.generateUid('UserInfo');
		this.polling = this.polling.bind(this);
		this.doPoll = this.doPoll.bind(this);
		this.sortedPlayers = this.sortedPlayers.bind(this);
		const mo = G.getStatus('mainOperation');
		if (mo?.params?.tab === 'UserList') this.polling(true);
	}
	componentDidMount() {
		G.register('Players', ps => {
			this.setState({ players : ps} );
		}, this.uid);
		G.register('mainOperation', mo => {
			this.polling( mo?.params?.tab === 'UserList' );
		}, this.uid);
		this.setState({mounted:true});
	}
	componentWillUnmount() {
		G.deregister( this.uid );
		this.setState({mounted:false});
	}
	polling(trigger= false) {
		if ( ! this.state.mounted ) {
			setTimeout( ()=>{ this.polling(trigger) }, 500);
			return;
		}
		if ( this.state.timeout ) try {
			window.clearTimeout(this.state.timeout);
		} catch( e ) {}
		this.setState({
			polling: !! trigger,
			timeout: trigger && this.state.mounted && window.setTimeout( ()=>{ this.doPoll() }, 10 )
		});
	}
	doPoll() {
		if ( this.state.players && Array.isArray(this.state.players) && this.state.players.length ) {
			this.setState( { traffic: true } );
			G.api( { entity:'playerstatus', operation: 'list'} ).then( ulast =>{
				const ps = 	this.state.players;
				ps.forEach( p => {
					const ul = ulast.player.find( up => (up.id === p.id) );
					if ( ul ) {
						p.last = ul.last
						p.delay = ulast.update - ul.last;
						if ( p.delay > 86400000 ) delete p.delay;
					} else {
						delete p.last;
						delete p.delay;
					}
				});
				this.setState({ players: ps });
			}).catch( e => {
				console.error(e);
			}).finally( ()=>{
				this.setState({
					traffic: false,
					timeout: this.state.polling && window.setTimeout( ()=>{ this.doPoll() }, this.state.pollInterval )
				});
			});
		} else {
			this.setState({
				timeout: this.state.polling && window.setTimeout( ()=>{ this.doPoll() }, this.state.pollInterval )
			});
		}
	}
	sortedPlayers() {
		const key = this.state.sorter;
		const rev = !! this.state.revsort;
		return this.state.players.sort( (a,b) => {
			if ( key === 'time' ) {
				if ( (b.delay ?? Infinity) > (a.delay ?? Infinity ) ) return rev ? -1 : 1;
			} else {
				if ( a.name.toLowerCase() > b.name.toLowerCase() ) return rev ? -1 : 1;
			}
			return rev ? 1 : -1;
		});
	}
	render() {
		if ( ! this.state.players ) return <p/>;
		return (
			<div
				className={"UserList"}
				id={this.uid}
			>
				<h1>
					<TextLabel value={"UserList"}/>
				</h1>
				<div className={ this.state.traffic ? 'busy' : '' }>
					<span>
						<TextLabel value={"network"} lang={"icon"} />
					</span>
				</div>
				<table>
					<thead>
					<tr>
						<th></th>
						<th onClick={() => {
							this.setState({sorter: 'username', revsort: !this.state.revsort});
						}}>
							<TextLabel value={"Username"}/>
						</th>
						<th onClick={() => {
							this.setState({sorter: 'time', revsort: !this.state.revsort});
						}}>
							<TextLabel value={"Last known activity"}/>
						</th>
						<th onClick={() => {
							this.setState({sorter: 'time', revsort: !this.state.revsort});
						}}>
							<TextLabel value={"Delay"}/>
						</th>
					</tr>
					</thead>
					<tbody>
					{this.sortedPlayers().map(p => {
						let c = 'unk';
						if (p.delay) {
							if (p.delay < 180000) c = 'online';
							else if (p.delay < 600000) c = 'idle';
							else c = 'offline';
						}
						return (
							<tr key={p.id}>
								<td>
									<span className={`playerStatus ${c} ${p.delay}`}/>
								</td>
								<td>
									{ p.name}
								</td>
								<td>
									{ p.last ? (new Date(p.last)).toLocaleString() : ''}
								</td>
								<td>
									{ p.delay ? appLib.msec2string(p.delay) : ''}
								</td>
							</tr>
						);
					})}
					</tbody>
				</table>
			</div>
		);
	}
}

export default UserList;